import { ContainerProvider } from '@hub-la/fe-container'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import { QueryParamProvider } from 'use-query-params'
import { QueryParamAdapter } from './components/query-param-adapter'

const queryClient = new QueryClient()

export const DashboardProductsProvider = ({ children, container }) => {
  return (
    <QueryParamProvider adapter={QueryParamAdapter}>
      <ContainerProvider container={container}>
        <I18nextProvider i18n={i18n}>
          <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </I18nextProvider>
      </ContainerProvider>
    </QueryParamProvider>
  )
}
